import { render, staticRenderFns } from "./OfferCreateTaxes.vue?vue&type=template&id=148115bd&scoped=true&"
import script from "./OfferCreateTaxes.vue?vue&type=script&lang=ts&"
export * from "./OfferCreateTaxes.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCreateTaxes.vue?vue&type=style&index=0&id=148115bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148115bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VForm,VRow})
